import { revitServices } from "@/mocks/serviceRevitData";

export default function RevitServices() {
  return (
    <section
      id="servicios"
      className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50"
    >
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Nuestros servicios
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Servicios de modelado y coordinación BIM
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Acompañamos tu proyecto desde el modelado inicial hasta la documentación técnica final,
            garantizando precisión y coordinación.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {revitServices.map((service, i) => (
            <div
              key={service.title}
              className="reveal rounded-xl border border-background-200 bg-background-50 p-6 hover:border-[#0087a4]/40 transition-colors"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 rounded-lg bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{service.description}</p>
            </div>
          ))}

          <div className="reveal rounded-xl border border-[#0087a4]/30 bg-[#0087a4]/5 p-6 flex flex-col justify-center items-start">
            <div className="w-12 h-12 rounded-lg bg-[#0087a4] text-white flex items-center justify-center mb-4">
              <i className="ri-phone-line text-2xl" />
            </div>
            <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug">
              ¿Necesitas asesoría?
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Contáctanos y te ayudamos a definir la mejor solución de modelado BIM para tu proyecto.
            </p>
            <a
              href="https://wa.me/573232209100"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-md bg-[#0087a4] text-white text-sm font-semibold hover:bg-[#006f86] transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2" />
              Escribir ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}